<script setup>
import { ref } from 'vue';
import Button from '@components/Button.vue';

defineProps({
    id: {
        type: String,
        required: true,
        default: '',
    },
    title: {
        type: String,
        required: true,
        default: '',
    },
    buttonLabel: {
        type: String,
        default: '',
    },
});

const expanded = ref(false);
</script>

<template>
    <section
        :id="id"
        :data-section-title="title"
        class="relative mb-20 lg:mb-40 flex flex-col items-center gap-y-5 sm:gap-y-10 h-auto scroll-mt-32 pt-10 lg:pt-20 -mt-10 lg:-mt-20 transition duration-200 ease-in-out"
        :data-expanded="expanded"
    >
        <div class="px-5 md:container-content space-y-16">
            <div v-if="!expanded">
                <slot name="intro" />
            </div>

            <template v-else>
                <slot />
            </template>
        </div>

        <Button
            :aria-controls="id"
            :aria-expanded="expanded"
            :aria-label="expanded ? $t('Collapse section') : $t('Expand section')"
            size="sm"
            variant="default"
            @click="expanded = !expanded"
            class="w-fit"
            :class="{
                'translate-y-1/2': expanded,
            }"
        >
            <span v-if="!expanded">{{ buttonLabel }}</span>
            <span v-else>{{ $t('Collapse') }}</span>
        </Button>
    </section>
</template>

<style scoped>
section[data-expanded=true] {
    box-shadow: 0 0 99px 1px inset rgba(0, 0, 0, 0.22);
}
</style>
